(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("angular"), require("angular-ui-router"));
	else if(typeof define === 'function' && define.amd)
		define("opkOAuth", ["angular", "angular-ui-router"], factory);
	else if(typeof exports === 'object')
		exports["opkOAuth"] = factory(require("angular"), require("angular-ui-router"));
	else
		root["opkOAuth"] = factory(root["angular"], root["angular-ui-router"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_9__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(8);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(9);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _oauthCallback = __webpack_require__(1);
	
	var _oauthCallback2 = _interopRequireDefault(_oauthCallback);
	
	var _oauthConfig = __webpack_require__(5);
	
	var _oauthConfig2 = _interopRequireDefault(_oauthConfig);
	
	var _oauthUser = __webpack_require__(6);
	
	var _oauthUser2 = _interopRequireDefault(_oauthUser);
	
	var _token = __webpack_require__(7);
	
	var _token2 = _interopRequireDefault(_token);
	
	var _uiRouterInterceptor = __webpack_require__(4);
	
	var _uiRouterInterceptor2 = _interopRequireDefault(_uiRouterInterceptor);
	
	var _token3 = __webpack_require__(2);
	
	var _token4 = _interopRequireDefault(_token3);
	
	var _tokenParam = __webpack_require__(3);
	
	var _tokenParam2 = _interopRequireDefault(_tokenParam);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module("opileak.oauth", [_angularUiRouter2.default]).component("oauthCallback", _oauthCallback2.default).provider("oauthConfig", _oauthConfig2.default).service("tokenService", _token2.default).service("OAuthUserService", _oauthUser2.default).factory("tokenInjector", _token4.default).factory("tokenParamInjector", _tokenParam2.default).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state({
	    name: 'oauth_callback',
	    url: '/oauth_callback?access_token&token_type&state&expires_in&scope&jti&user_show_name',
	    component: 'oauthCallback'
	  });
	}]).run(_uiRouterInterceptor2.default).name;

/***/ },
/* 1 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OauthCallbackController = function () {
	  OauthCallbackController.$inject = ["OAuthUserService", "tokenService", "$stateParams"];
	  function OauthCallbackController(OAuthUserService, tokenService, $stateParams) {
	    "ngInject";
	
	    _classCallCheck(this, OauthCallbackController);
	
	    this.userService = OAuthUserService;
	    this.params = $stateParams;
	    this.tokenService = tokenService;
	  }
	
	  _createClass(OauthCallbackController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var token = this.params.access_token;
	      if (!token) {
	        return;
	      }
	      this.tokenService.setToken(token);
	
	      if (this.params.user_show_name) {
	        this.tokenService.setDecodedUsername(decodeURI(this.params.user_show_name));
	      }
	
	      this.userService.login();
	    }
	  }]);
	
	  return OauthCallbackController;
	}();
	
	exports.default = {
	  template: "<h1>Redireccionando</h1>",
	  controller: OauthCallbackController,
	  controllerAs: "opk"
	};

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';
	
	tokenInteceptorFactory.$inject = ["tokenService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = tokenInteceptorFactory;
	/* @ngInject */
	function tokenInteceptorFactory(tokenService) {
	  return {
	    request: function request(config) {
	      if (tokenService.getToken() !== null && !config.ignoreTokenInterceptor) {
	        config.headers['Authorization'] = 'Bearer ' + tokenService.getToken();
	      }
	      return config;
	    }
	  };
	}

/***/ },
/* 3 */
/***/ function(module, exports) {

	"use strict";
	
	tokenParamInterceptor.$inject = ["oauthConfig", "tokenService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = tokenParamInterceptor;
	/* @ngInject */
	function tokenParamInterceptor(oauthConfig, tokenService) {
	  return {
	    request: function request(reqConfig) {
	      var token = tokenService.getToken();
	      var isApiCall = reqConfig.url.indexOf(oauthConfig.api) !== -1;
	      if (isApiCall && token && !reqConfig.ignoreTokenInterceptor) {
	        var urlHasParams = reqConfig.url.indexOf("?") !== -1;
	        var prefix = urlHasParams ? "&" : "?";
	        reqConfig.url += prefix + "access_token=" + token;
	      }
	      return reqConfig;
	    }
	  };
	}

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	uiRouterInterceptor.$inject = ["oauthConfig", "$transitions", "OAuthUserService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = uiRouterInterceptor;
	/* @ngInject */
	function uiRouterInterceptor(oauthConfig, $transitions, OAuthUserService) {
	  $transitions.onStart({}, function (transition) {
	    var $state = transition.router.stateService;
	    var toState = transition.$to();
	    var toParams = transition.params();
	    var stateIsProtected = typeof toState.role !== 'undefined';
	    var userIsLogged = OAuthUserService.userIsLogged();
	    var userCanEnterState = OAuthUserService.userHasRole(toState.role);
	
	    if (!stateIsProtected) {
	      return;
	    }
	    if (!userIsLogged) {
	      var redirection = JSON.stringify({
	        nextState: toState.name,
	        nextParams: toParams
	      });
	      sessionStorage.setItem('opk_oauth_temp_redirect', redirection);
	      return $state.target(oauthConfig.loginState);
	    }
	    if (userIsLogged && !userCanEnterState) {
	      return $state.target(oauthConfig.no_role_redirect);
	    }
	  });
	}

/***/ },
/* 5 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var oauthConfigProvider = function () {
	  function oauthConfigProvider() {
	    "ngInject";
	
	    _classCallCheck(this, oauthConfigProvider);
	
	    var domain = document.baseURI || window.location.origin + window.location.pathname;
	
	    // si aqui se pone una varaible a null
	    // esta debera ser configurada por la aplicacion que use este modulo
	    this.config = {
	      CLIENT_ID: null,
	      loginState: null,
	      no_role_redirect: null,
	      user_roles: null,
	      user_redirects: null,
	      login_callback_url: domain + "#/oauth_callback?",
	      logout_callback_url: domain,
	      authentificationServer: "http://oauth.opileak.es",
	      authentificationApi: "http://oauth-api.opileak.es/0"
	    };
	  }
	
	  _createClass(oauthConfigProvider, [{
	    key: "configure",
	    value: function configure(options) {
	      Object.assign(this.config, options);
	    }
	  }, {
	    key: "$get",
	    value: function $get() {
	      var _this = this;
	
	      var missingProps = [];
	      Object.keys(this.config).forEach(function (key) {
	        var value = _this.config[key];
	        if (value === null) {
	          missingProps.push(key);
	        }
	      });
	      if (missingProps.length > 0) {
	        throw new Error("oauthConfigProvider no ha recibido la configuracion necesaria.\n                       \nPor favor, configure las siguientes opciones usando\n                       oauthConfigProvider.configure: \n " + missingProps.join(", "));
	      }
	      return this.config;
	    }
	  }]);
	
	  return oauthConfigProvider;
	}();
	
	exports.default = oauthConfigProvider;

/***/ },
/* 6 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function isObject(value) {
	  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	  return value != null && (type == 'object' || type == 'function');
	}
	
	var OAuthUserService = function () {
	  OAuthUserService.$inject = ["$http", "$state", "tokenService", "oauthConfig"];
	  function OAuthUserService($http, $state, tokenService, oauthConfig) {
	    "ngInject";
	
	    _classCallCheck(this, OAuthUserService);
	
	    this.http = $http;
	    this.$state = $state;
	    this.tokenService = tokenService;
	    this.config = oauthConfig;
	    this.user = null;
	  }
	
	  _createClass(OAuthUserService, [{
	    key: 'fetchUsers',
	    value: function fetchUsers(params) {
	      var url = this.config.authentificationApi + '/user';
	      return this.http.get(url, { params: params }).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getTokenData',
	    value: function getTokenData(token) {
	      var data = token.split('.');
	      data = data[1];
	      data = atob(data);
	      data = JSON.parse(data);
	
	      if (this.tokenService.getDecodedUsername()) {
	        data.user_show_name = this.tokenService.getDecodedUsername();
	      }
	
	      return data;
	    }
	  }, {
	    key: 'tokenDataIsValid',
	    value: function tokenDataIsValid(tokenData) {
	      var expirationDate = tokenData.exp * 1000;
	      var now = Date.now();
	      return expirationDate > now;
	    }
	  }, {
	    key: 'login',
	    value: function login() {
	      var token = this.tokenService.getToken();
	      if (token) {
	        // nuevo flujo de login
	        // 1. descodificar token
	        // 2. guardar datos descodificados como datos de usuario
	        // 3. comprobar si el token esta caducado
	        //   3.1 si esta ok, this.redirectUserByRole()
	        //   3.2 si esta caducado, llevar a tokenService.getLoginEndpoint()
	
	        this.user = this.getTokenData(token);
	        if (this.tokenDataIsValid(this.user)) {
	          var redirect = sessionStorage.getItem('opk_oauth_temp_redirect');
	          if (redirect) {
	            redirect = JSON.parse(redirect);
	            sessionStorage.removeItem('opk_oauth_temp_redirect');
	            this.$state.go(redirect.nextState, redirect.nextParams);
	          } else {
	            this.redirectUserByRole();
	          }
	        } else {
	          console.log("OauthUserService: token caducado. pidiendo de nuevo");
	          this.tokenService.setToken(null);
	          window.location.href = this.tokenService.getLoginEndpoint();
	        }
	      } else {
	        window.location.href = this.tokenService.getLoginEndpoint();
	      }
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      this.user = null;
	      this.tokenService.setToken(null);
	      window.location.href = this.tokenService.getLogoutEndpoint();
	    }
	  }, {
	    key: 'redirectUserByRole',
	    value: function redirectUserByRole() {
	      var _this = this;
	
	      var roleKeys = Object.keys(this.config.user_roles);
	      var selectedKeys = roleKeys.filter(function (key) {
	        var role = _this.config.user_roles[key];
	        return _this.userHasRole(role);
	      });
	      this.goToRole(selectedKeys[0]);
	    }
	  }, {
	    key: 'goToRole',
	    value: function goToRole(role_key) {
	      var badlogin = this.config.no_role_redirect;
	      var state = role_key ? this.config.user_redirects[role_key] : badlogin;
	      if (isObject(state)) {
	        this.$state.go(state.name, state.params);
	      } else {
	        this.$state.go(state);
	      }
	    }
	  }, {
	    key: 'userIsLogged',
	    value: function userIsLogged() {
	      return !!this.user;
	    }
	  }, {
	    key: 'userHasRole',
	    value: function userHasRole(role) {
	      var _this2 = this;
	
	      // caso de uso especial
	      if (role === "ANY") {
	        return this.userIsLogged();
	      }
	      if (Array.isArray(role)) {
	        return role.some(function (role) {
	          return _this2.getUserRoles().indexOf(role) !== -1;
	        });
	      }
	      return this.getUserRoles().indexOf(role) !== -1;
	    }
	  }, {
	    key: 'getUserRoles',
	    value: function getUserRoles() {
	      return this.userIsLogged() ? this.user.authorities : [];
	    }
	  }, {
	    key: 'getUserId',
	    value: function getUserId() {
	      return this.userIsLogged() ? this.user.uuid : null;
	    }
	  }, {
	    key: 'getUserName',
	    value: function getUserName() {
	      return this.userIsLogged() ? this.user.user_show_name : null;
	    }
	  }]);
	
	  return OAuthUserService;
	}();
	
	exports.default = OAuthUserService;

/***/ },
/* 7 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TokenService = function () {
	  TokenService.$inject = ["oauthConfig", "$httpParamSerializer"];
	  function TokenService(oauthConfig, $httpParamSerializer) {
	    "ngInject";
	
	    _classCallCheck(this, TokenService);
	
	    this.config = oauthConfig;
	    this.paramSerializer = $httpParamSerializer;
	    this.decodedUsername = null;
	  }
	
	  _createClass(TokenService, [{
	    key: 'setToken',
	    value: function setToken(token) {
	      this.token = token;
	    }
	  }, {
	    key: 'getToken',
	    value: function getToken(token) {
	      return this.token;
	    }
	  }, {
	    key: 'setDecodedUsername',
	    value: function setDecodedUsername(username) {
	      this.decodedUsername = username;
	    }
	  }, {
	    key: 'getDecodedUsername',
	    value: function getDecodedUsername() {
	      return this.decodedUsername;
	    }
	  }, {
	    key: 'getLoginEndpoint',
	    value: function getLoginEndpoint() {
	      var server = this.config.authentificationServer;
	      var params = this.paramSerializer({
	        response_type: 'token',
	        client_id: this.config.CLIENT_ID,
	        redirect_uri: this.config.login_callback_url,
	        scope: '',
	        state: ''
	      });
	      return server + '/oauth/authorize?' + params;
	    }
	  }, {
	    key: 'getLogoutEndpoint',
	    value: function getLogoutEndpoint() {
	      var server = this.config.authentificationServer;
	      var params = this.paramSerializer({
	        redirecturl: this.config.logout_callback_url
	      });
	      return server + '/logout?' + params;
	    }
	  }]);
	
	  return TokenService;
	}();
	
	exports.default = TokenService;

/***/ },
/* 8 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ },
/* 9 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_9__;

/***/ }
/******/ ])
});
;


// WEBPACK FOOTER //
// angular-opileak-oauth.min.js